import styled from 'foundations-theming/utils';
import { useSelector } from 'react-redux';
import { useMarketerSectionsAlertTypeMessageAndTitle } from './InpageSectionsHooks';
import { CardGrid } from 'foundations-components/transitional/components/CardGrid';
import InpageDraggableSection from './InpageDraggableSection';
import EmptyCustomSectionColumn from 'ContentEditorUI/components/sections/EmptyCustomSectionColumn';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getMarketerSectionsLimitInfo, getMarketerSectionsLimit } from 'ContentEditorUI/redux/selectors/templateInfoSelectors';
import { PATAGONIA_ADD_PANEL_CATEGORIES } from 'ContentEditorUI/js/constants/Sidebar';
import { H5 } from 'foundations-components/transitional/components/H5';
import { PATAGONIA_ADD_PANEL_SUB_CATEGORIES } from 'ContentEditorUI/constants/Sidebar';
import { getHasReachedEmbedLimit } from 'ContentEditorUI/redux/selectors/moduleSelectors';
import { isEmbed } from 'ContentEditorUI/types/Section';
import InpageDraggableThemeSectionContainer from './InpageDraggableThemeSectionContainer';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SectionsSeparator = styled.div.withConfig({
  displayName: "InpageSectionSearchResultsContainer__SectionsSeparator"
})(({
  theme
}) => ({
  borderWidth: theme.borderWidth['100'],
  borderStyle: 'solid',
  borderColor: theme.color['border-core-subtle'],
  margin: theme.space['800']
}));
export default function InpageAllSectionsContainer({
  onDragStart,
  onDragEnd,
  sidebarSearchResultsMap,
  searchQuery
}) {
  const filteredSavedSections = sidebarSearchResultsMap[PATAGONIA_ADD_PANEL_CATEGORIES.SECTIONS][PATAGONIA_ADD_PANEL_SUB_CATEGORIES.SECTIONS.SAVED].results;
  const filteredThemeSections = sidebarSearchResultsMap[PATAGONIA_ADD_PANEL_CATEGORIES.SECTIONS][PATAGONIA_ADD_PANEL_SUB_CATEGORIES.SECTIONS.THEME].results;
  const filteredThemelessSections = sidebarSearchResultsMap[PATAGONIA_ADD_PANEL_CATEGORIES.SECTIONS][PATAGONIA_ADD_PANEL_SUB_CATEGORIES.SECTIONS.NO_THEME].results;
  const marketerSectionsLimitInfo = useSelector(getMarketerSectionsLimitInfo);
  const hasReachedEmbedLimit = useSelector(getHasReachedEmbedLimit);
  const marketerSectionsLimit = useSelector(getMarketerSectionsLimit);
  const [alertType, alertMessage, alertTitle] = useMarketerSectionsAlertTypeMessageAndTitle(marketerSectionsLimitInfo);
  if (filteredSavedSections.length === 0 && filteredThemeSections.length === 0 && filteredThemelessSections.length === 0) {
    return /*#__PURE__*/_jsx(EmptyCustomSectionColumn, {
      title: "addSectionPanel.customSections.patagonia.noCustomSectionsTitle",
      searchQuery: searchQuery
    });
  }
  const shouldShowMarketerSectionsLimitAlert = alertType !== null;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [shouldShowMarketerSectionsLimitAlert && /*#__PURE__*/_jsx(Alert, {
      type: alertType,
      titleText: alertTitle,
      marginBlockEnd: "400",
      marginBlockStart: "300",
      children: alertMessage
    }), filteredSavedSections.length > 0 && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(H5, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "inpage.layout.addSection.savedSections",
          options: {
            count: filteredSavedSections.length,
            limit: marketerSectionsLimit
          }
        })
      }), /*#__PURE__*/_jsx(CardGrid, {
        columns: 1,
        gutterSize: 10,
        marginBlockStart: "400",
        children: filteredSavedSections.map(section => /*#__PURE__*/_jsx(InpageDraggableSection, {
          section: section,
          onDragStart: onDragStart,
          onDragEnd: onDragEnd,
          isDraggable: !marketerSectionsLimitInfo.isOverLimit
        }, `${section.id}-${section.name}`))
      })]
    }), filteredSavedSections.length > 0 && filteredThemeSections.length > 0 && /*#__PURE__*/_jsx(SectionsSeparator, {}), filteredThemeSections.length > 0 && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(H5, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "inpage.layout.addSection.themeSections",
          options: {
            count: filteredThemeSections.length
          }
        })
      }), /*#__PURE__*/_jsx(CardGrid, {
        columns: 1,
        gutterSize: 10,
        marginBlockStart: "400",
        children: filteredThemeSections.map(section => {
          const key = isEmbed(section) ? `${section.id}-${section.name}` : `${section.id}-${section.label}`;
          return /*#__PURE__*/_jsx(InpageDraggableThemeSectionContainer, {
            section: section,
            onDragStart: onDragStart,
            onDragEnd: onDragEnd
          }, key);
        })
      })]
    }), (filteredSavedSections.length > 0 || filteredThemeSections.length > 0) && filteredThemelessSections.length > 0 && /*#__PURE__*/_jsx(SectionsSeparator, {}), filteredThemelessSections.length > 0 && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(H5, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "inpage.layout.addSection.noThemeSections",
          options: {
            count: filteredThemeSections.length
          }
        })
      }), /*#__PURE__*/_jsx(CardGrid, {
        columns: 1,
        gutterSize: 10,
        marginBlockStart: "400",
        children: filteredThemelessSections.map(embed => /*#__PURE__*/_jsx(InpageDraggableSection, {
          section: embed,
          onDragStart: onDragStart,
          onDragEnd: onDragEnd,
          isDraggable: !hasReachedEmbedLimit
        }, `${embed.id}-${embed.name}`))
      })]
    })]
  });
}